module.exports = __webpack_public_path__ + "media/andenes/nivelador_vertical-20ad392e.webp";